import PaystackPop from '@paystack/inline-js';
import Toastify from 'toastify-js';
import "toastify-js/src/toastify.css";

document.addEventListener('DOMContentLoaded', (e) => {
	const idBtnPlaceHolder = 'learn-press-checkout-place-order';
	const idPageCheckout = 'learn-press-checkout';
	const idPaystackForm = 'lp-paystack-payment-form';
	const lpCheckoutForm = document.getElementById( 'learn-press-checkout-form' );
	if ( ! lpCheckoutForm ) {
		return;
	}
	const paystackForm = document.getElementById( idPaystackForm );
	if ( ! paystackForm ) {
		return;
	}
	document.addEventListener( 'click', (e) => {
		let target = e.target;
		if ( target.id === idBtnPlaceHolder ) {
			const btnPlaceHolder = target;
			const formData = new FormData( lpCheckoutForm );
			if ( formData.get( 'payment_method' ) !== 'paystack' ) {
				return;
			}
			e.preventDefault();
			const email = paystackForm.querySelector( '#lp-paystack-email' );
			if ( ! isValidEmail( email.value ) ) {
				showMessage( 'error', lpPaystackSetting.invalid_email_text );
				return;
			}
			btnPlaceHolder.classList.add( 'loading' );
			btnPlaceHolder.disabled = true;
			btnPlaceHolder.innerText = lpCheckoutSettings.i18n_processing;

			let urlHandle = new URL( lpCheckoutSettings.ajaxurl );
			urlHandle.searchParams.set( 'lp-ajax', 'checkout' );
			fetch( urlHandle, {
				method: 'POST',
				headers: {
					'X-WP-Nonce': lpPaystackSetting.nonce,
				},
				body: formData,
			} )
				.then( ( res ) => res.text() )
				.then( ( data ) => {
					data = lpAjaxParseJsonOld( data );
					btnPlaceHolder.disabled = false;
					btnPlaceHolder.classList.remove( 'loading' );
					// console.log(data);
					if ( data.result === 'processing' ) {
						initializePayment( data, email.value );
					} else {
						showMessage( 'error', data?.message || data?.messages );
						btnPlaceHolder.innerText = lpCheckoutSettings.i18n_place_order;
					}
				} )
				.finally( () => {} )
				.catch( ( err ) => console.log( err ) );
		}
	} );
	const initializePayment = ( data, email ) => {
		const paystack = new PaystackPop();
		paystack.newTransaction({
			key: lpPaystackSetting.public_key,
			email: email,
			amount: data.options.amount,
			currency: lpPaystackSetting.currency,
			ref: data.options.ref,
			metadata: {
			  lp_order_id: data.options.lp_order_id
			},
			onSuccess: function(response) {
				const updatedUrl = new URL(data.options.redirect_url); // Parse the URL
			    updatedUrl.searchParams.set('lp-paystack-ref', response.reference);
			    window.location.href = updatedUrl.href;
			},
			onCancel: function() {
				// Handle popup closed
				showMessage( 'warning', lpPaystackSetting.cancel_order_text );
			},
			onError: (error) => {
				console.log("Error: ", error.message);
				showMessage( 'error', error.message );
			}
		});
	}
	// Ultils
	const lpAjaxParseJsonOld = ( data ) => {
		if ( typeof data !== 'string' ) {
			return data;
		}

		const m = String.raw( { raw: data } ).match( /<-- LP_AJAX_START -->(.*)<-- LP_AJAX_END -->/s );

		try {
			if ( m ) {
				data = JSON.parse( m[ 1 ].replace( /(?:\r\n|\r|\n)/g, '' ) );
			} else {
				data = JSON.parse( data );
			}
		} catch ( e ) {
			data = {};
		}

		return data;
	};
	const showMessage = (status, message) => {
        Toastify({
            text: message,
            gravity: lpData.toast.gravity, // `top` or `bottom`
            position: lpData.toast.position, // `left`, `center` or `right`
            className: `${lpData.toast.classPrefix} ${status}`,
            close: lpData.toast.close == 1,
            stopOnFocus: lpData.toast.stopOnFocus == 1,
            duration: lpData.toast.duration,
        }).showToast();
    };
    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };
});